import { FixedSimpleDropdown } from "src/base-components/FixedSimpleDropdown";
import { Input } from "src/base-components/Input";
import { RelativeTimePoint, TimeUnit } from "src/clients/jobs";

type TimedeltaPickerProps = {
  isDatetime: boolean;
  value: Pick<RelativeTimePoint, "offset" | "unit"> | null;
  onChange: (value: Pick<RelativeTimePoint, "offset" | "unit">) => void;
};

const dateUnitOptions = [
  {
    key: TimeUnit.DAYS,
    value: "Days",
  } as const,
  {
    key: TimeUnit.WEEKS,
    value: "Weeks",
  } as const,
];

const datetimeUnitOptions = [
  {
    key: TimeUnit.HOURS,
    value: "Hours",
  } as const,
  ...dateUnitOptions,
];

export const TimedeltaPicker: React.FC<TimedeltaPickerProps> = ({
  isDatetime,
  value,
  onChange,
}) => {
  const { offset, unit } = value ?? { offset: -1, unit: TimeUnit.DAYS };

  return (
    <div
      className="flex items-center gap-x-4 px-4 py-3"
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
    >
      <div className="max-w-[100px]">
        <Input
          data-loc="relative-time-amount-input"
          max={999}
          min={1}
          type="number"
          value={Math.abs(offset)}
          fullWidth
          onChange={(e) => {
            const newOffset = -1 * Number(e.target.value || 1);
            onChange({
              offset: newOffset,
              unit,
            });
          }}
        />
      </div>
      <div className="flex-1">
        <FixedSimpleDropdown
          buttonDataLoc="relative-time-unit-selector-button"
          dataLoc="relative-time-unit-selector"
          elements={isDatetime ? datetimeUnitOptions : dateUnitOptions}
          placeholder="unit"
          selectedKey={unit}
          onSelect={(newUnit) => {
            onChange({
              offset,
              unit: newUnit as TimeUnit,
            });
          }}
        />
      </div>
      <div className="basis-[24px]">
        <span className="text-gray-800 font-inter-medium-13px">ago</span>
      </div>
    </div>
  );
};
